import { BiteLogCardConnectEvent } from './bite_log_card_connect_event.js';

export function name(event: BiteLogCardConnectEvent): string {
  switch (event) {
    case BiteLogCardConnectEvent.TerminalDisconnected:
      return 'terminal-disconnected';
    case BiteLogCardConnectEvent.UpdateIdleTextError:
      return 'update-idle-text-error';
    case BiteLogCardConnectEvent.AuthAndCaptureDeprecated:
      return 'transaction-authorization-and-capture';
  }
}
